import { Prompt, PromptGroup, PromptResponse } from 'sellDirect/helpers/closingDash/disclosures';
import { OdProtosRubricV2Data_Prompt_Type as PromptType } from '__generated__/globalTypes';
import { MultiSelectQuestion } from 'sellDirect/components/closingDash/disclosures/DynamicDisclosures/MultiSelectQuestion';
import { SingleSelectQuestion } from 'sellDirect/components/closingDash/disclosures/DynamicDisclosures/SingleSelectQuestion';
import { TextQuestion } from 'sellDirect/components/closingDash/disclosures/DynamicDisclosures/TextQuestion';

export interface QuestionProps {
  question: Prompt;
  promptGroup: PromptGroup;
  showErrors?: boolean;
}

/**
 * component-test-check-ignore
 * storybook-check-ignore
 */
export const Question: React.FC<QuestionProps> = ({ question, promptGroup, showErrors }) => {
  const onResponseChange = (value: PromptResponse | null) => {
    question.response = value;
  };

  switch (question.type) {
    case PromptType.FREEFORM:
      return (
        <TextQuestion
          question={question}
          onResponseChange={onResponseChange}
          showErrors={showErrors}
        />
      );
    case PromptType.SINGLE_SELECT: {
      return (
        <SingleSelectQuestion
          question={question}
          promptGroup={promptGroup}
          onResponseChange={onResponseChange}
          showErrors={showErrors}
        />
      );
    }
    case PromptType.MULTIPLE_SELECT: {
      return (
        <MultiSelectQuestion
          question={question}
          promptGroup={promptGroup}
          onResponseChange={onResponseChange}
          showErrors={showErrors}
        />
      );
    }
  }
  return null;
};
